import { hbs } from 'ember-cli-htmlbars';
export default hbs("<span>\n  {{config \"APP.tenant\"}}\n  •\n  {{config \"APP.env\"}}\n  •\n  {{config \"APP.version\"}}\n</span>")